import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLogoWiggotBlack from '../build/icon-logo-wiggot-black'

export const IconLogoWiggotBlackComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconLogoWiggotBlack} />
}

export default IconLogoWiggotBlackComponent
